import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { useTranslations } from "use-intl";
import { UpdateBookingInput } from "@/gql/graphql";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { updateBookingMutation } from "@/app/Bookings/GraphQL/bookingMutations";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { useBooking } from "@/app/Bookings/Hooks/useBooking";
import { SupplierInsuranceOptionInput } from "@/app/Suppliers/Components/SupplierInsuranceOptionInput";

export function BookingChangeInsuranceDialog({
  bookingId,
}: {
  bookingId: string;
}) {
  const t = useTranslations("booking.cards.changeInsuranceDialog");
  const booking = useBooking(bookingId);
  const { mutateAsync } = useGqlMutation(updateBookingMutation);
  const { close } = useDialogState();

  return (
    <BaseDialog title={t("title")}>
      <GenericForm<UpdateBookingInput>
        initialValues={{
          supplierInsuranceOption: {
            connect: booking.supplierInsuranceOption.id,
          },
        }}
        onSubmit={async (values) => {
          await mutateAsync({
            id: booking.id,
            input: values,
          });

          await close();
        }}
      >
        <SupplierInsuranceOptionInput
          name="supplierInsuranceOption.connect"
          label={t("insuranceLabel")}
          className="col-span-full"
          getQueryVariables={(search) => ({
            page: 1,
            first: 20,
            search,
            supplierId: booking.supplier.id,
          })}
          initialFixtureValues={{
            supplier: {
              connect: booking.supplier.id,
            },
          }}
        />

        <DialogSubmitButton text={t("submit")} />
      </GenericForm>
    </BaseDialog>
  );
}
